import React, { ComponentProps } from 'react'
import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import {
  RecipeFooterRoot,
  ContentWrapper,
  RecipeFooterText,
  BorderWrapper,
} from './RecipeFooter.styles'
import { CtaButton } from 'components/CtaButton'
import type * as Stitches from '@stitches/react'

type RecipeFooterOwnProps = ComponentProps<typeof RecipeFooterRoot>
type RecipeFooterRootVariants = Stitches.VariantProps<typeof RecipeFooterRoot>

type RecipeFooterProps = {
 bg?: RecipeFooterRootVariants['background'];
 cta: string;
 header: string;
 ctaLink: string;
} & RecipeFooterOwnProps

export const RecipeFooter = (_props: RecipeFooterProps) => {
  const { t } = useTranslation()

  const { bg, cta, header, ctaLink } = _props

  return (
    <RecipeFooterRoot background={bg}>
      <BorderWrapper
          bottom
          background="primary-500"
          svgHeight="64px"
          svgWidth="calc(144% + 1.3px)"
          path="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
        />
        <ContentWrapper
          gap="3"
          css={{ height: '100%', zIndex: 1 }}
          justifyContent="center"
          direction="column"
          alignItems="center"
        >
          <RecipeFooterText size="h5" as="p" weight="medium" color="accent-white" align="center">
            {header}
          </RecipeFooterText>
          <Link href={ctaLink}>
            <CtaButton type="secondary">{cta}</CtaButton>
          </Link>
        </ContentWrapper>
    </RecipeFooterRoot>
  )
}

RecipeFooter.displayName = 'RecipeFooter'
